<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/144qI4L/tc-custom/9780292768093.jpg?1703819676915" alt="This image is the cover for the book Texas, A Modern History, Bridwell Texas History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texas, A Modern History, Bridwell Texas History Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Revised and updated, this popular history by an award-winning</b><b> author brings the story of Texas into the twenty-first century.</b></p><p>Since its publication in 1989, <i>Texas, A Modern History</i> has established itself as one of the most readable and reliable general histories of Texas. David McComb paints the panorama of Lone Star history from the earliest Indians to the present day with a vigorous brush that uses fact, anecdote, and humor to present a concise narrative. The book is designed to offer an adult reader the savor of Texan culture, an exploration of the ethos of its people, and a sense of the rhythm of its development. Spanish settlement, the Battle of the Alamo, the Civil War, cattle trails, oil discovery, the growth of cities, changes in politics, the Great Depression, World War II, recreation, economic expansion, and recession are each a part of the picture. Photographs and fascinating sidebars punctuate the text.</p><p>In this revised edition, McComb not only incorporates recent scholarship but also tracks the post–World War II rise of the Republican Party in Texas and the evolution of the state from rural to urban, with 88 percent of the people now living in cities. At the same time, he demonstrates that, despite many changes that have made Texas similar to the rest of the United States, much of its unique past remains.</p><b>“Contrary to popular belief, there is more to Texas history than the Alamo and oil gushers. This book takes us from the early Indians of the area through to modern times when people began to realize the exploitation of natural resources and pollution were ruining the state’s natural beauty. The author offers many stories and an ample helping of anecdotes and folklore to paint an accurate portrait of the state and the people who have made it great.” —<i>American West</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David G. McComb
      </h2>
      
      <p class="authorDescription body article">DAVID MCCOMB grew up in Houston and is an emeritus professor of history at Colorado State University. He has written extensively about Texas history, including award-winning books on Houston and Galveston, as well as about Colorado and sports.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3af1d32f